import type { SwitchboardFlowData } from '../converters/shared/reactFlowTypes'
import {
  getPersistedGraphComparableSignature,
  hasPersistedGraphChanges,
  type SignatureRefContext,
} from '../utils/switchboardFlowSignature'

export function getDraftComparableFlowSignature(
  flowData: SwitchboardFlowData,
  refContext?: SignatureRefContext,
): string {
  return getPersistedGraphComparableSignature(flowData, refContext)
}

export function hasDraftRelevantChanges(
  previousFlowData: SwitchboardFlowData,
  nextFlowData: SwitchboardFlowData,
  refContext?: SignatureRefContext,
): boolean {
  return hasPersistedGraphChanges(previousFlowData, nextFlowData, refContext)
}
